import React, { useEffect, useState } from "react";

import HttpManager from "../../../services/HttpManager";
import { MetasTablero } from "../../../services/v2/prospects.service";
import { errorTexto } from "./salesHelpers";
import { logoDe } from "./tableroView";

interface Props { campusId: number; onGuardado: () => void; }

const PAIS: { [k: string]: string } = { hn: "Honduras", mx: "México" };

/**
 * Metas por equipo (Esteban, 2026-11-04: "haz la pantalla"): Dirección y Super Admin las cambian aquí; los demás solo las ven.
 * Una meta por equipo y mes (la misma todos los meses hasta que la cambien). Logo, color y sonido no se tocan desde aquí.
 */
const TableroMetas: React.FC<Props> = ({ campusId, onGuardado }) => {
	const http = HttpManager.getInstance();
	const [datos, setDatos] = useState<MetasTablero | null>(null);
	const [metas, setMetas] = useState<{ [k: string]: string }>({});
	const [error, setError] = useState<string | null>(null);
	const [aviso, setAviso] = useState<string | null>(null);
	const [busy, setBusy] = useState(false);

	const cargar = () => http.prospectsService.tableroEquipos(campusId).then((r) => {
		setDatos(r.data);
		const m: { [k: string]: string } = {};
		r.data.equipos.forEach((e) => { m[e.pais + "|" + e.equipo] = String(e.meta); });
		setMetas(m);
	}).catch((e) => setError(errorTexto(e)));
	useEffect(() => { cargar(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [campusId]);

	const cambiados = datos ? datos.equipos.filter((e) => Number(metas[e.pais + "|" + e.equipo]) !== e.meta) : [];
	const invalidos = datos ? datos.equipos.filter((e) => { const v = Number(metas[e.pais + "|" + e.equipo]); return !(v >= 0 && v <= 9999); }) : [];

	const guardar = () => {
		if (!datos) return;
		setBusy(true); setError(null); setAviso(null);
		http.prospectsService.guardarMetas(campusId, cambiados.map((e) => ({ pais: e.pais, equipo: e.equipo, meta: Number(metas[e.pais + "|" + e.equipo]) })))
			.then((r) => {
				setDatos(r.data);
				const m: { [k: string]: string } = {};
				r.data.equipos.forEach((e) => { m[e.pais + "|" + e.equipo] = String(e.meta); });
				setMetas(m);
				setAviso(cambiados.length === 1 ? "Meta guardada." : cambiados.length + " metas guardadas.");
				onGuardado();
			})
			.catch((e) => setError(errorTexto(e)))
			.finally(() => setBusy(false));
	};

	if (error && !datos) return <div className="aviso error">{error}</div>;
	if (!datos) return <div className="ventas-vacio">Cargando…</div>;
	return (
		<div className="tarjeta tb-ventas">
			<div className="tarjeta-cab">
				<h4>Metas por equipo</h4>
				<span className="apagado">Matrículas del mes{datos.puedeEditar ? "" : " · solo Dirección las cambia"}</span>
			</div>
			<div className="waScrollX">
				<table className="tb-tabla tb-metas">
					<thead><tr><th>Equipo</th><th>País</th><th>Meta</th></tr></thead>
					<tbody>
						{datos.equipos.map((e) => {
							const k = e.pais + "|" + e.equipo;
							const cambio = Number(metas[k]) !== e.meta;
							return (
								<tr key={k} className={cambio ? "tb-meta-cambiada" : ""}>
									<td><span className="tb-meta-eq" style={{ "--col": e.color || "var(--wa-apagado)" } as React.CSSProperties}><img src={logoDe(e)} alt="" />{e.equipo}</span></td>
									<td className="apagado">{PAIS[e.pais] || e.pais}</td>
									<td>
										{datos.puedeEditar
											? <input type="number" min={0} max={9999} step={1} value={metas[k] ?? ""} disabled={busy} aria-label={"Meta de " + e.equipo}
												onChange={(ev) => setMetas({ ...metas, [k]: ev.target.value })} style={{ width: 96 }} />
											: <b>{e.meta}</b>}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			{error ? <div className="aviso error">{error}</div> : null}
			{aviso ? <div className="aviso">{aviso}</div> : null}
			{datos.puedeEditar ? (
				<div className="tb-editar-botones">
					<button type="button" className="btn btn-primary btn-sm rounded-pill" disabled={busy || !cambiados.length || invalidos.length > 0} onClick={guardar}>
						{cambiados.length > 1 ? "Guardar " + cambiados.length + " metas" : "Guardar"}
					</button>
					{cambiados.length ? <button type="button" className="btn btn-link btn-sm" disabled={busy} onClick={() => { const m: { [k: string]: string } = {}; datos.equipos.forEach((e) => { m[e.pais + "|" + e.equipo] = String(e.meta); }); setMetas(m); }}>Deshacer</button> : null}
				</div>
			) : null}
		</div>
	);
};

export default TableroMetas;
